const DEFAULT_VISIT_MINUTES = 60;

const toIcsDateTime = (date) =>
  date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

// Builds a data: URI .ics file for the customer's free initial visit, so
// "Add to calendar" works without any backend endpoint or third-party
// calendar API — the browser downloads/opens it directly.
export const buildBookingCalendarUrl = ({
  scheduledDate,
  scheduledTime,
  service,
  bookingNumber,
}) => {
  if (!scheduledDate || !scheduledTime) return null;

  const [hours, minutes] = scheduledTime.split(':').map(Number);
  const [year, month, day] = scheduledDate.split('-').map(Number);
  const start = new Date(year, month - 1, day, hours, minutes);
  const end = new Date(start.getTime() + DEFAULT_VISIT_MINUTES * 60 * 1000);

  const title = `PaveMend site visit${service ? ` — ${service}` : ''}`;
  const description = `Free initial visit with PaveMend${
    bookingNumber ? ` (booking ${bookingNumber})` : ''
  }.`;

  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//PaveMend//Booking//EN',
    'BEGIN:VEVENT',
    `UID:${bookingNumber || Date.now()}@pavemend.co.uk`,
    `DTSTAMP:${toIcsDateTime(new Date())}`,
    `DTSTART:${toIcsDateTime(start)}`,
    `DTEND:${toIcsDateTime(end)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${description}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  return `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`;
};
